module.exports = __webpack_public_path__ + "static/img/logo_12.ad8d8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_12.png
// module id = TCOH
// module chunks = 1